import {AnalyticsService} from '../../../shared/services/analytics/analytics.service';
import {PathUrlEnum} from '../../../utils/analytics.utils';
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {DataPersonalSellerPf} from '../../../shared/models/SellerPf.model';
import {ErrorMessage} from '../../../shared/models/error-message';
import {
  documents,
  estado_civil,
  interdito,
  nationalities,
  orgaoExpedidorCnh,
  orgaoExpedidorRg,
  orgaoExpedidorRne,
  regime_bens,
  sexo,
  states,
} from '../../../utils/constants.utils';
import PatternsUtils from '../../../utils/patterns.utils';
import {validatorCNPJ, validatorCPF} from '../../../utils/validators';
import {filter} from 'rxjs';
import {mapFormToDataPersonalSellerPfOne} from "../../../utils/seller-pf-mapper.util";
import {patchFormWithNestedObject} from "../../../utils/seller-mapper.utils";
import {EstadoCivil} from "../../../shared/enums/estadoCivil.enum";
import {DocumentType} from "../../../shared/enums/documentType.enum";
import CpfHelper from "../../../helpers/cpf.helper";
import {CepService} from "../../../shared/services/cep/cep.service";
import {ICityResponse} from "../../../shared/interfaces/ICepResponse";
import {StatusService} from "../../../shared/services/authentication/status.service";
import { addNameSanitizers, emailValidator, textMinCharsValidator, textNoSpecialCharsValidator } from '../../../helpers/validate-form.helper';

import { phoneMask } from '../../../utils/masks.utils';
import { birthDateValidator } from '../../../helpers/birth-date.helper';

@Component({
  selector: 'app-seller-step-one-pf',
  templateUrl: './seller-step-one-pf.component.html',
  styleUrls: ['./seller-step-one-pf.component.scss'],
})
export class SellerStepOnePfComponent implements OnInit {
  @Output() formsComplete = new EventEmitter();

  @Output() dataForms = new EventEmitter<DataPersonalSellerPf>();

  @Input() dataPersonal = new DataPersonalSellerPf();

  formStepOne: FormGroup;




  infoDataCasamento =
    'a data de casamento informada deve ser a data no cartório ou do religioso com efeito civil.';

  infoProcurador =
    'se você está representado por um procurador, é obrigatório o envio da procuração.';

  showError = false;

  errorMessage = '';

  listStates = [...states];

  listCities: ICityResponse[] = [];
  loadingCities = false;

  listaOrgaoExpedidor: { optValue: string; optLabel: string }[] = [];

  listaDocumentos = [...documents];

  listaEstadoCivil = [...estado_civil];

  listaSexo = [...sexo];

  listNacionalites = [...nationalities];

  listaRegimeBens = [...regime_bens];

  listaEspolio = [...interdito];

  docNumMinLen = 8;

  docNumMaxLen = 8;

  phoneMask = phoneMask;

  maskCpfCnpj = CpfHelper.maskCpfCnpj;

  constructor(
    private analyticsService: AnalyticsService,
    private cepService: CepService,
    private statusService: StatusService,
  ) {
  }

  ngOnInit(): void {
    this.initForm();
    this.getFormData(this.formStepOne, this.dataPersonal);
    this.isFormComplete();
    this.analyticsService.track(PathUrlEnum.PROPRIETARIO_PF_DADOS_PESSOAIS);
  }

  getErrorMandatory(label: string): string {
    return ErrorMessage.getTextMandatory(label);
  }

  getEmailFieldError(controlName: string, label: string): string {
    const control = this.formStepOne.get(controlName);
    return ErrorMessage.getEmailFieldError(control, label);
  }

  getForgotFill(label: string): string {
    return ErrorMessage.forgotFill(label);
  }
   validatedate(control: FormControl): { [key: string]: any } | null {
  return birthDateValidator(control.value);
}

    getTextFieldError(controlName: string, label: string): string {
    const control = this.formStepOne.get(controlName);
    return ErrorMessage.getTextFieldError(control, label);
  }

  getErrorInvalid(label: string): string {
    return ErrorMessage.getTextInvalid(label);
  }

  getErrorInvalidValue(label: string): string {
    return ErrorMessage.getTextInvalidValue(label);
  }



getDateFieldError(controlName: string, label: string): string {
  const control = this.formStepOne.get(controlName);
  return ErrorMessage.getBirthDateFieldError(control, label);
}

getBirthDateFieldError(controlName: string, label: string): string {
  const control = this.formStepOne.get(controlName);
  return ErrorMessage.getBirthDateFieldError(control, label);
}

normalizeEmail(controlName: string): void {
  const control = this.formStepOne.get(controlName);
  if (!control) return;

  const value = (control.value || '').toString().trim().toLowerCase();

  if (value !== control.value) {
    control.setValue(value);
  }
}

  initForm() {
    this.formStepOne = new FormGroup({
      name: new FormControl('', [
         Validators.required,
          textMinCharsValidator(),
          textNoSpecialCharsValidator(),
      ]),
      documentNumber: new FormControl({value: '', disabled: true}, [
        Validators.required,
        Validators.pattern(PatternsUtils.CPF_MAX_14_CHARS),
      ]),
      birth_date: new FormControl('', [
      Validators.required, birthDateValidator
      ]),
      birth_state: new FormControl(''),
      birth_city: new FormControl('', [
        Validators.required,
        Validators.pattern(PatternsUtils.ONLY_LETTERS_WITH_HYPHEN),
      ]),
      gender: new FormControl('', [Validators.required]),
      birth_nationality: new FormControl('', [Validators.required]),
      profession: new FormControl('', [Validators.required]),
      relationship_maritalStatus: new FormControl('', [Validators.required]),

      relationship_propertyRegime: new FormControl(''),
      relationship_marriageDate: new FormControl(''),
      relationship_hasStableUnion: new FormControl(null),
      relationship_hasPartInSale: new FormControl(null),

      document_type: new FormControl('', [Validators.required]),
      document_number: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(8),
        Validators.pattern(PatternsUtils.ONLY_NUMBER_AND_LETTERS),
      ]),
      document_issueDate: new FormControl('', [
        Validators.required,
        birthDateValidator,
      ]),
      document_issuingAuthority: new FormControl('', [Validators.required]),
      document_issuingAuthorityState: new FormControl('', [Validators.required]),

      parentage_motherName: new FormControl('', [
        Validators.required,
        textMinCharsValidator(),
        textNoSpecialCharsValidator(),
      ]),
      parentage_fatherName: new FormControl('', [
        textMinCharsValidator(),
        textNoSpecialCharsValidator(),
      ]),

      contact_email: new FormControl('', [
        Validators.required,
        emailValidator,
      ]),
      contact_phone: new FormControl('', [Validators.required, Validators.minLength(10)]),

      address_zipCode: new FormControl('', [Validators.required, Validators.minLength(8)]),
      address_state: new FormControl('', [Validators.required]),
      address_city: new FormControl('', [Validators.required]),
      address_district: new FormControl('', [Validators.required]),
      address_street: new FormControl('', [Validators.required]),
      address_number: new FormControl(''),
      address_complement: new FormControl(''),

      deliveryAddress_isLocale: new FormControl(null, [Validators.required]),
      deliveryAddress_zipCode: new FormControl(''),
      deliveryAddress_state: new FormControl(''),
      deliveryAddress_city: new FormControl(''),
      deliveryAddress_district: new FormControl(''),
      deliveryAddress_street: new FormControl(''),
      deliveryAddress_number: new FormControl(''),
      deliveryAddress_complement: new FormControl(''),

      vendedor_pf_pj: new FormControl(''),
      vendedor_razao_social: new FormControl(''),
      attorneyData_useAttorney: new FormControl('', [Validators.required]),
      attorneyData_fullName: new FormControl(''),
      attorneyData_documentNumber: new FormControl(''),
      attorneyData_email: new FormControl(''),
      attorneyData_phone: new FormControl(''),

      additionalInformation_hasEmployee: new FormControl('', [Validators.required]),
      additionalInformation_isSellingToFamily: new FormControl('', [Validators.required]),
      additionalInformation_isUnderAge: new FormControl('', [Validators.required]),
      additionalInformation_situation: new FormControl(''),
    });

    this.formStepOne
      .get('birth_nationality')
      ?.valueChanges.pipe(filter(() => !this.formStepOne.get('birth_nationality')?.pristine))
      .subscribe({
        next: sellerNationality => {
          if (sellerNationality?.toLocaleLowerCase() !== 'brasileira') {
            this.formStepOne.get('birth_state')?.setValue('');
            this.formStepOne.get('birth_state')?.disable();
            this.clearValidation('birth_state');
          } else {
            this.formStepOne.get('birth_state')?.enable();
            this.updateValidators('birth_state', [Validators.required]);
            this.formStepOne.get('birth_city')?.disable();
          }
        },
      });

    this.formStepOne.get('birth_state')?.valueChanges.subscribe({
      next: (value) => {
        if (value) {
          this.getCities(value);
          this.formStepOne.get('birth_city')?.enable();
        } else {
          this.formStepOne.get('birth_city')?.setValue('');
          if (this.formStepOne.get('birth_nationality')?.value?.toLocaleLowerCase() !== 'brasileira') {
            this.formStepOne.get('birth_city')?.enable();
          }
        }
      },
    });

    this.formStepOne.get('relationship_maritalStatus')?.valueChanges.subscribe({
      next: () => {
        this.clearValue('relationship_propertyRegime');
        this.clearValue('relationship_marriageDate');
        this.clearValue('relationship_hasPartInSale');
        this.formStepOne.get('relationship_hasStableUnion')?.setValue(false);
      },
    });

    this.formStepOne.get('document_type')?.valueChanges.subscribe({
      next: sellerDocumentType => {
        this.clearValue('document_number');
        this.clearValue('document_issuingAuthority');
        this.clearValue('document_issueDate');
        this.clearValue('document_issuingAuthorityState');

        this.listaOrgaoExpedidor = [];
        this.docNumMinLen = 8;
        this.docNumMaxLen = 8;

        if (sellerDocumentType === DocumentType.RG) {
          this.formStepOne
            .get('document_number')
            ?.setValidators([
              Validators.required,
              Validators.minLength(6),
              Validators.maxLength(15),
              Validators.pattern(PatternsUtils.ONLY_NUMBER_AND_LETTERS),
            ]);
          this.docNumMinLen = 6;
          this.docNumMaxLen = 15;
          this.listaOrgaoExpedidor = [...orgaoExpedidorRg];
        }

        if (sellerDocumentType === DocumentType.RNE) {
          this.formStepOne
            .get('document_number')
            ?.setValidators([
              Validators.required,
              Validators.maxLength(8),
              Validators.minLength(8),
              Validators.pattern(PatternsUtils.ONLY_NUMBER_AND_LETTERS),
            ]);
          this.docNumMinLen = 8;
          this.docNumMaxLen = 8;
          this.listaOrgaoExpedidor = [...orgaoExpedidorRne];
        }

        if (sellerDocumentType === DocumentType.CNH) {
          this.formStepOne
            .get('document_number')
            ?.setValidators([
              Validators.required,
              Validators.minLength(9),
              Validators.maxLength(11),
              Validators.pattern(PatternsUtils.ONLY_NUMBERS),
            ]);
          this.docNumMinLen = 9;
          this.docNumMaxLen = 11;
          this.listaOrgaoExpedidor = [...orgaoExpedidorCnh];
        }
      },
    });

    this.formStepOne.controls.parentage_fatherName.valueChanges.subscribe({
      next: sellerFathersName => {
        if (
          sellerFathersName?.trim() === this.formStepOne.get('parentage_motherName')?.value?.trim()
        ) {
          this.formStepOne.controls.parentage_fatherName.setErrors({
            invalid: 'Mesmo nome da mãe.',
          });
        }
      },
    });

    this.formStepOne.get('vendedor_pf_pj')?.valueChanges.subscribe({
      next: isPfOrPj => {
        if (isPfOrPj === 'pessoa física') {
          this.clearValidation('vendedor_razao_social');
          this.clearValue('vendedor_razao_social');
          this.updateValidators('attorneyData_fullName', [
            Validators.required,
             textMinCharsValidator(),
        textNoSpecialCharsValidator(),
          ]);
        }

        if (isPfOrPj === 'pessoa jurídica') {
          this.clearValidation('attorneyData_fullName');
          this.clearValue('attorneyData_fullName');
          this.updateValidators('vendedor_razao_social', [
            Validators.required,
             textMinCharsValidator(),
              textNoSpecialCharsValidator(),
          ]);
        }
      },
    });

    addNameSanitizers(this.formStepOne, {
  controlNames: [
    'name',
    'parentage_motherName',
    'parentage_fatherName',
    'attorneyData_fullName'
  ]
});
  }

  civiStateChange(civilState: string) {
    if (civilState.toLowerCase() === EstadoCivil.CASADO.toLowerCase()) {
      this.setMarriedValidators();
      this.clearSingleValidators();
    } else {

      this.setSingleValidators();
      this.clearMarriedValidators();
    }
  }

  setSingleValidators() {
    this.updateValidators('relationship_hasStableUnion', [Validators.required]);
    this.updateValidators('relationship_hasPartInSale', [Validators.required]);
    this.clearValidation('relationship_propertyRegime');
    this.clearValidation('relationship_marriageDate');
  }

  clearSingleValidators() {
    this.clearValidation('relationship_hasStableUnion');
    this.clearValue('relationship_hasStableUnion');
    this.clearValue('relationship_hasPartInSale');
  }

  setMarriedValidators() {
    this.updateValidators('relationship_propertyRegime', [Validators.required]);
    this.updateValidators('relationship_marriageDate', [
      Validators.required,
      birthDateValidator,
    ]);
    this.updateValidators('relationship_hasPartInSale', [Validators.required]);
  }

  clearMarriedValidators() {
    this.clearValidation('relationship_propertyRegime');
    this.clearValidation('relationship_marriageDate');
    this.clearValidation('relationship_hasPartInSale');
    this.clearValue('relationship_propertyRegime');
    this.clearValue('relationship_marriageDate');
  }

  get isMarried() {
    return this.dataPersonal.relationship.maritalStatus === EstadoCivil.CASADO;
  }

  get isSingle() {
    return this.dataPersonal.relationship.maritalStatus !== EstadoCivil.CASADO;
  }

  get isSpouseParticipates() {
    return (this.isSingle && this.dataPersonal.relationship?.hasStableUnion);
  }

  get isProxyData() {
    return !!this.dataPersonal?.attorneyData && this.dataPersonal?.attorneyData?.useAttorney;
  }

  getCities(uf: string): void {
    this.loadingCities = true;
    this.cepService.getCities(uf).subscribe({
      next: (response) => {
        this.listCities = response.data;
        if (!this.listCities.find(city => city.name === this.formStepOne.get('birth_city')?.value)) {
          this.formStepOne.get('birth_city')?.setValue(null, { emitEvent: true });
          this.formStepOne.get('birth_city')?.updateValueAndValidity();
        }
        this.loadingCities = false;

      },
      error: () => {
        this.loadingCities = false;
        this.statusService.showToast(
          'error',
          'desculpe, não conseguimos carregar a lista de cidades',
        );
      }
    })
  }

  stableUnionChange(stableUnion: boolean) {
    if (stableUnion) {
      this.clearValue('relationship_hasPartInSale');
      this.updateValidators('relationship_hasPartInSale', [Validators.required]);
      this.clearValidation('relationship_propertyRegime');
      this.clearValidation('relationship_marriageDate');
      this.setMarriedValidators();
    } else {
      this.clearValidation('relationship_hasPartInSale');
      this.clearValue('relationship_hasPartInSale');
      this.clearValue('relationship_propertyRegime');
      this.clearValue('relationship_marriageDate');
      this.clearValue('relationship_hasPartInSale');
    }
  }

  postLocationChange(isLocale: boolean) {
    if (isLocale) {
      this.clearValidation('deliveryAddress_zipCode');
      this.clearValidation('deliveryAddress_street');
      this.clearValidation('deliveryAddress_state');
      this.clearValidation('deliveryAddress_number');
      this.clearValidation('deliveryAddress_complement');
      this.clearValidation('deliveryAddress_city');
      this.clearValidation('deliveryAddress_district');
      this.clearValue('deliveryAddress_zipCode');
      this.clearValue('deliveryAddress_street');
      this.clearValue('deliveryAddress_state');
      this.clearValue('deliveryAddress_number');
      this.clearValue('deliveryAddress_complement');
      this.clearValue('deliveryAddress_city');
      this.clearValue('deliveryAddress_district');
    } else {
      this.updateValidators('deliveryAddress_zipCode', [Validators.required, Validators.minLength(8)]);
      this.updateValidators('deliveryAddress_street', [Validators.required]);
      this.updateValidators('deliveryAddress_state', [Validators.required]);

      this.updateValidators('deliveryAddress_city', [Validators.required]);
      this.updateValidators('deliveryAddress_district', [Validators.required]);
    }
  }

  isOtherLocation() {
    return !!this.dataPersonal?.deliveryAddress && !this.dataPersonal?.deliveryAddress?.isLocale;
  }

  checkValidCpfCnpj() {
    let validators = [Validators.required];

    if (this.formStepOne.controls['attorneyData_documentNumber'].value.length <= 11) {
      validators.push(validatorCPF, Validators.pattern(PatternsUtils.CPF_MAX_14_CHARS));
    } else {
      validators.push(validatorCNPJ, Validators.pattern(PatternsUtils.CNPJ));
    }

    this.updateValidators('attorneyData_documentNumber', validators);
  }

  procuratorChange(useAttorney: boolean) {
    if (useAttorney) {
      this.formStepOne.controls.vendedor_pf_pj.setValue('pessoa física');
      this.updateValidators('vendedor_pf_pj', [Validators.required]);
      this.updateValidators('attorneyData_fullName', [
        Validators.required,
         textMinCharsValidator(),
        textNoSpecialCharsValidator(),
      ]);
      this.updateValidators('attorneyData_phone', [
        Validators.required,
        Validators.minLength(10),
      ]);
      this.updateValidators('attorneyData_email', [
        Validators.required,
        emailValidator,
      ]);
    } else {
      this.clearValidation('attorneyData_documentNumber');
      this.clearValidation('attorneyData_fullName');
      this.clearValidation('attorneyData_email');
      this.clearValidation('attorneyData_phone');
      this.clearValue('attorneyData_documentNumber');
      this.clearValue('attorneyData_fullName');
      this.clearValue('attorneyData_email');
      this.clearValue('attorneyData_phone');
    }
  }

  updateValidators(key: string, validators: ValidatorFn[] | null = null) {
    this.formStepOne.controls[key].setValidators(validators);
    this.formStepOne.controls[key].updateValueAndValidity();
  }

  clearValidation(key: string) {
    this.formStepOne.controls[key].setValidators(null);
    this.formStepOne.controls[key].setErrors(null);
  }

  clearValue(key: string) {
    this.formStepOne.get(key)?.patchValue('');
  }

  getFormData(formGroup: FormGroup, data: DataPersonalSellerPf): void {
    patchFormWithNestedObject(formGroup, data);
  }

  assetChange(isAsset: boolean) {
    if (isAsset) {
      this.updateValidators('additionalInformation_situation', [Validators.required]);
    } else {
      this.clearValidation('additionalInformation_situation');
      this.clearValue('additionalInformation_situation');
    }
  }

  isFormComplete() {
    this.formStepOne.statusChanges.subscribe(newStatus => {
      const formValue = this.formStepOne.getRawValue();
      Object.assign(this.dataPersonal, mapFormToDataPersonalSellerPfOne(formValue));
      if (newStatus.toLowerCase() === 'valid') {
        this.formsComplete.emit(true);
        this.dataForms.emit(this.dataPersonal);
      } else {
        this.formsComplete.emit(false);
      }
    });
  }

  isAssets() {
    return this.dataPersonal.additionalInformation.isUnderAge;
  }
}
